$(function () {
  // ページ描画時は登録ボタンをdisabledにする
  $('#submit-button').prop('disabled', true);

  // 利用規約に同意のチェックボックスに連動し、disabledをスイッチする
  $('#checkbox-read-terms').on('click', function () {
    if ($(this).prop('checked') == false) {
      $('#submit-button').prop('disabled', true);
    } else {
      $('#submit-button').prop('disabled', false);
    }
  });
});
